<!-- Container-fluid starts-->
<div class="container">
    <div class="row">
        <div class="col-sm-3 info-stat-block">
            <!-- Left panel -->
            <div class="vendu">
                <div class="number">{{this.provider.nbProductsSold}}</div>
                <div class="number-info">Produit<span *ngIf="this.provider.nbProductsSold > 1">s</span> vendu<span *ngIf="this.provider.nbProductsSold > 1">s</span>
                </div>
            </div>
            <div class="refuse">
                <div class="number">{{this.provider.nbOrderRefused}}</div>
                <div class="number-info">Commande<span *ngIf="this.provider.nbOrderRefused > 1">s</span> refusée<span *ngIf="this.provider.nbOrderRefused > 1">s</span>
                </div>
            </div>
        </div>
        <!-- Right panel -->
        <div class="col-sm-8 offset-1 info-block">
            <div class="nom-id">
                {{this.provider.providerName}}
            </div>
            <div class="info">
                <div class="d-flex flex-row">
                    <div class="d-flex flex-column flex-50 user-image">
                        <div class="logo_account">
                            <img alt="" [src]="url? url:'assets/images/banner/1.jpg'">
                        </div>
                        <div class="produit">
                            <div class="number">{{this.provider.nbProductsTotal}}</div>
                            <div class="number-info">Produit<span *ngIf="this.provider.nbProductsTotal > 1">s</span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-50">
                        <p class="title">Localisation</p>
                        <!-- Address -->
                        <div class="info-detail-block d-flex flex-row">
                            <i class="fa fa-home" aria-hidden="true"></i>
                            <div>
                                <p>{{this.provider.adressStreet}}</p>
                                <p>{{this.provider.adressState}}</p>
                                <p>{{this.provider.adressPostalCode}} {{this.provider.adressCity}}
                                    <span *ngIf="this.provider.adressCountry">,</span>
                                    {{this.provider.adressCountry}}
                                </p>
                            </div>
                        </div>
                        <!-- Geolocation -->
                        <div class="info-detail-block d-flex flex-row">
                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                            <div>
                                <p *ngIf="this.provider.geolocation">{{this.provider.geolocation}}</p>
                            </div>
                        </div>
                        <!-- Contact -->
                        <p class="title">Contact</p>
                        <div class="info-detail-block d-flex flex-row">
                            <i class="fa fa-envelope-o" aria-hidden="true"></i>
                            <div>
                                <p>{{this.provider.email}}</p>
                            </div>
                        </div>
                        <div class="info-detail-block d-flex flex-row">
                            <i class="fa fa-phone" aria-hidden="true"></i>
                            <div>
                                <p>{{this.provider.phone}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_container_account">
                <button class="modify modify-info btn_modify_info" (click)="openAccountModification()">
                    Modifier mes informations
                    <span>
                        <i class="fa fa-edit fa-lg" aria-hidden="true"></i>
                    </span>
                </button>
                <button class="modify modify-pass btn_modify_pwd" (click)="openAccountModificationPassword()">
                    Modifier mon mot de passe
                    <span>
                        <i class="fa fa-lock fa-lg" aria-hidden="true"></i>
                    </span>
                </button>
                <button class="delete delete-pass btn_delete" (click)="openDeleteAccount()">
                    Supprimer mon compte
                    <span>
                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
  <!-- Container-fluid Ends-->